import { React, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

export default function NotFoundView(props) {
  const { firstText, secondText } = props;

  const [count, setCount] = useState(5);

  // 카운트다운 //
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        if (prev <= 1) { clearInterval(interval); return 1; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [])

  return (
    <TopLevelWrapper>
      <TextWrapper>
        <ExplanationText color='#595959'>{firstText}</ExplanationText>
        <ExplanationText color='#595959'>{secondText}</ExplanationText>
      </TextWrapper>
      <FiveSecondsTextWrapper>
        <FiveSecondsText>{count}초뒤 메인화면으로 이동합니다</FiveSecondsText>
      </FiveSecondsTextWrapper>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 78.5%;
  height: 92.93%;

  margin-top: 28px;

  z-index: 1;

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const ExplanationText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 19px;
  }
  @media (min-height: 640px) {
    font-size: 20px;
  }
  @media (min-height: 720px) {
    font-size: 21px;
  }
  @media (min-height: 760px) {
    font-size: 22px;
  }
  @media (min-height: 800px) {
    font-size: 23px;
  }
  @media (min-height: 1000px) {
    font-size: 24px;
  }
  @media (min-height: 1200px) {
    font-size: 30px;
  }

  &:hover {
    cursor: default;
  }
`;

const FiveSecondsTextWrapper = styled.div`
  position: absolute;
  bottom: 10%;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const FiveSecondsText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #FF8B48;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 14px;
  }
  @media (min-height: 680px) {
    font-size: 14px;
  }
  @media (min-height: 720px) {
    font-size: 15px;
  }
  @media (min-height: 760px) {
    font-size: 16px;
  }
  @media (min-height: 800px) {
    font-size: 18px;
  }
  @media (min-height: 1000px) {
    font-size: 20px;
  }
  @media (min-height: 1200px) {
    font-size: 22px;
  }
`;
